module.exports = ".boldText {\r\n    font-weight:bold;\r\n}"